import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTheme } from '@mui/material/styles';
import { ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';
import { IconLogout } from '@tabler/icons';

import useAuth from 'hooks/useAuth';
import { SET_MENU } from 'store/actions';
import { DefaultRootStateProps, NavItemType } from 'types';

/** התנתקות מהמגירה — אותה לוגיקה כמו בפרופיל (handleLogout ב־ProfileSection). */
const NavLogout = ({ item, level }: { item: NavItemType; level: number }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { logout } = useAuth();
    const borderRadius = useSelector((state: DefaultRootStateProps) => state.customization.borderRadius);
    const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));

    const Icon = item.icon ?? IconLogout;

    const handleClick = useCallback(async () => {
        if (matchesSM) dispatch({ type: SET_MENU, opened: false });
        try {
            await logout();
        } catch (err) {
            console.error(err);
        }
    }, [dispatch, logout, matchesSM]);

    return (
        <ListItemButton
            component="div"
            onClick={handleClick}
            sx={{
                borderRadius: `${borderRadius}px`,
                mb: 0.5,
                alignItems: 'flex-end',
                py: level > 1 ? 1 : 1.25,
                pl: `${level * 24}px`,
                marginInlineStart: 'auto',
                width: 'fit-content',
                maxWidth: '100%',
                alignSelf: 'flex-start',
                color: theme.palette.error.main,
                '&:hover': {
                    backgroundColor:
                        theme.palette.mode === 'dark' ? 'rgba(244, 67, 54, 0.12)' : 'rgba(244, 67, 54, 0.08)'
                }
            }}
        >
            <ListItemIcon sx={{ my: 'auto', minWidth: 36, color: 'inherit' }}>
                <Icon stroke={1.5} size="1.3rem" />
            </ListItemIcon>
            <ListItemText
                primary={
                    <Typography variant="body1" color="inherit">
                        {item.title}
                    </Typography>
                }
            />
        </ListItemButton>
    );
};

export default React.memo(NavLogout);
